import { ShieldOff } from 'lucide-react';

import { EmptyState } from '~/components/ui/empty-state';

export interface NoPermissionProps {
  /** What the person is not allowed to view, e.g. "AI Manager". */
  resource: string;
}

/** The DESIGN.md §11.3 refusal block — rendered in place, never a redirect. */
export function NoPermission({ resource }: NoPermissionProps) {
  return (
    <EmptyState
      icon={<ShieldOff className="size-8" aria-hidden="true" />}
      title="No permission"
      description={`You do not have permission to view ${resource}.`}
    />
  );
}
